<template>
  <div v-if="potensialPromotion && potensialPromotion.length">
    <div class="od-bonus-trigger" @click="showModal = true">
      <div class="od-bonus-left">
        <div class="od-bonus-icon-wrap">
          <a-icon type="gift" />
        </div>
        <div>
          <p class="od-bonus-title">
            Bonus &amp; Hadiah
          </p>
          <p class="od-bonus-count">
            {{ potensialPromotion.length }} hadiah
          </p>
        </div>
      </div>
      <a-icon type="right" style="color:#d1d5db;font-size:16px;" />
    </div>

    <a-modal
      v-model="showModal"
      title="Bonus & Hadiah"
      :footer="null"
      width="480px"
    >
      <div style="background:#f8fafc;border-radius:12px;padding:12px 16px;margin-bottom:20px;display:flex;align-items:flex-start;gap:10px;">
        <a-icon type="info-circle" style="color:#64748b;margin-top:3px;" />
        <p style="font-size:11px;color:#475569;margin:0;line-height:1.6;">
          Bonus akan diberikan setelah pesanan berstatus <strong>Selesai</strong>.
        </p>
      </div>

      <div>
        <div
          v-for="(item, index) in potensialPromotion"
          :key="index"
          class="od-bonus-item"
        >
          <div class="od-bonus-item-icon">
            <a-icon :type="getGiftIcon(item.gift_type)" />
          </div>
          <div style="flex:1;min-width:0;">
            <p class="od-bonus-promo-type">
              {{ item.name || 'Hadiah' }}
            </p>

            <div v-if="item.gift_type === 'product' && item.gift && item.gift.length">
              <div v-for="(g, gi) in item.gift" :key="gi" style="display:flex;align-items:center;gap:8px;margin-top:4px;">
                <span style="font-size:11px;font-weight:700;color:#fff;background:#0f172a;padding:2px 8px;border-radius:6px;">{{ g.qty }} {{ g.uom }}</span>
                <span style="font-size:13px;font-weight:700;color:#0f172a;overflow:hidden;text-overflow:ellipsis;">{{ (g.catalog && g.catalog.title) || 'Produk Bonus' }}</span>
              </div>
            </div>
            <h4 v-else class="od-bonus-value">
              {{ formatGiftValue(item) }}
            </h4>

            <p class="od-bonus-meta">
              {{ getGiftTypeLabel(item.gift_type) }} • Diterima setelah selesai
            </p>
          </div>
        </div>
      </div>

      <div style="text-align:right;margin-top:16px;">
        <a-button @click="showModal = false">
          Tutup
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'OrderBonusSection',
  props: {
    potensialPromotion: { type: Array, default: () => [] },
    toCurrency: { type: Function, required: true },
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    getGiftIcon(type) {
      switch (type) {
        case 'coin': return 'dollar-circle'
        case 'voucher': return 'tag'
        case 'product': return 'inbox'
        case 'discount': return 'percentage'
        default: return 'star'
      }
    },
    getGiftTypeLabel(type) {
      switch (type) {
        case 'coin': return 'Koin'
        case 'voucher': return 'Voucher'
        case 'product': return 'Produk'
        case 'discount': return 'Diskon'
        default: return 'Spesial'
      }
    },
    formatGiftValue(item) {
      if (item.gift_type === 'coin') return `${Math.round(item.value || 0)} Koin`
      if (item.gift_type === 'voucher') {
        if (item.value_type === 'fixed') return this.toCurrency(Math.round(item.value || 0))
        return `${item.value}% Off`
      }
      if (item.gift_type === 'product' && item.gift && item.gift.length > 0) {
        const g = item.gift[0]
        return `${g.qty} ${g.uom} ${(g.catalog && g.catalog.title) || 'Produk Bonus'}`
      }
      if (item.gift_type === 'discount') {
        const gift = (item.gift && item.gift[0]) || {}
        if (gift.value_type === 'fixed') return this.toCurrency(Math.round(gift.value || 0))
        return `${Math.round(gift.value || 0)}${gift.value_type === 'percentage' ? '%' : ''}`
      }
      return item.name || 'Hadiah Spesial'
    },
  },
}
</script>
